const config = {
    version: "2.0.0",
    basename: "/",
    currentAppLocale: 'fa',
    drawerWidth: 240,
    snackbarAutoHideDuration: 3000,
    splashTime: 2500
}

export default config
